import { useState } from 'react';
import { SwitchInput, SwitchLabel, SwitchWrapper } from './Switch.styles';

const Switch = ({ id, disabled, defaultCheck = false, onChange }) => {
	const [isChecked, setIsChecked] = useState(defaultCheck);

	const handleChange = () => {
		onChange(!isChecked);
		setIsChecked((prevState) => !prevState);
	};

	return (
		<SwitchWrapper>
			<SwitchInput
				type='checkbox'
				id={`switch-${id}`}
				checked={isChecked}
				onChange={handleChange}
				disabled={disabled}
			/>
			<SwitchLabel
				htmlFor={`switch-${id}`}
				checked={isChecked}
				disabled={disabled}
			/>
		</SwitchWrapper>
	);
};

export default Switch;
